import { Box, Flex, Image, Text } from '@frontend/components';

interface GroupDisplayProps {
  logoURL: string;
  businessName: string;
  displayAddress: string | null;
}

export default function GroupDisplay({
  logoURL,
  businessName,
  displayAddress,
}: GroupDisplayProps) {
  return (
    <Box>
      <Flex paddingLeft="0.5rem" marginTop={'0.25rem'}>
        {logoURL && (
          <Image
            alt={'Companies'}
            src={logoURL}
            maxWidth="4.75rem"
            maxHeight="3rem"
            width="100%"
            padding="0.25rem"
            objectFit="contain"
          />
        )}
        <Flex direction="column" marginLeft="0.5rem" textAlign="left">
          <Text fontWeight="heavy" fontSize="md">
            {businessName}
          </Text>
          <Text color="feature.secondary" fontSize="sm">
            {displayAddress}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
}
